import script from "./TextEditorModal.vue?vue&type=script&setup=true&lang=js"
export * from "./TextEditorModal.vue?vue&type=script&setup=true&lang=js"

import "./TextEditorModal.vue?vue&type=style&index=0&id=403e10ec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-403e10ec"]])

export default __exports__